"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParametersServiceImpl = void 0;
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const ParameterImpl_1 = require("../../Impl/ParameterImpl");
const TableauError_1 = require("../../TableauError");
const ServiceImplBase_1 = require("./ServiceImplBase");
class ParametersServiceImpl extends ServiceImplBase_1.ServiceImplBase {
    get serviceName() {
        return "parameters-service" /* ServiceNames.Parameters */;
    }
    getParametersForSheetAsync(sheetPath) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'getParametersForSheetAsync',
            [api_internal_contract_js_1.ParameterId.SheetPath]: sheetPath,
        };
        return this.getParametersAsync(parameters);
    }
    getAllParametersAsync() {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'getParametersForSheetAsync',
        };
        return this.getParametersAsync(parameters);
    }
    getParametersAsync(inputParameters) {
        return this.execute(api_internal_contract_js_1.VerbId.GetParametersForSheet, inputParameters).then((response) => {
            const result = response.result;
            return result.map((parameterInfo) => {
                return new ParameterImpl_1.ParameterImpl(parameterInfo, this._registryId);
            });
        });
    }
    changeParameterValueAsync(fieldName, newValue) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'changeParameterValueAsync',
            [api_internal_contract_js_1.ParameterId.ParameterFieldName]: fieldName,
            [api_internal_contract_js_1.ParameterId.ParameterValue]: newValue,
        };
        return this.execute(api_internal_contract_js_1.VerbId.ChangeParameterValue, parameters).then((response) => {
            const result = response.result;
            return result;
        });
    }
    findParameterByNameAsync(name) {
        return this.findParameterAsync(name, undefined);
    }
    findParameterByGlobalFieldNameAsync(fieldName) {
        return this.findParameterAsync(undefined, fieldName);
    }
    findParameterAsync(name, fieldName) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'findParameterAsync',
        };
        if (name !== undefined) {
            parameters[api_internal_contract_js_1.ParameterId.ParameterCaption] = name;
        }
        else if (fieldName !== undefined) {
            parameters[api_internal_contract_js_1.ParameterId.ParameterFieldName] = fieldName;
        }
        else {
            throw new TableauError_1.TableauError(api_external_contract_js_1.ErrorCodes.InvalidParameter, 'name or fieldName must be provided to find parameter');
        }
        return this.execute(api_internal_contract_js_1.VerbId.FindParameter, parameters).then((response) => {
            const instanceOfParameterInfo = (object) => {
                return 'fieldName' in object;
            };
            // We need to check to see if we got a valid response back again
            if (instanceOfParameterInfo(response.result)) {
                const result = response.result;
                return new ParameterImpl_1.ParameterImpl(result, this._registryId);
            }
            else {
                return undefined;
            }
        });
    }
}
exports.ParametersServiceImpl = ParametersServiceImpl;
//# sourceMappingURL=ParametersServiceImpl.js.map